
(function(){
  var menuOpen=false;
  function qs(s,root){return (root||document).querySelector(s)}
  function qsa(s,root){return Array.prototype.slice.call((root||document).querySelectorAll(s))}
  function setMenu(open){
    menuOpen=open;
    var drawer=qs('#navDrawer'), backdrop=qs('#navDrawerBackdrop'), burger=qs('#navBurger');
    if(!drawer||!backdrop||!burger)return;
    drawer.classList.toggle('open',open);
    backdrop.classList.toggle('open',open);
    burger.classList.toggle('open',open);
    drawer.setAttribute('aria-hidden',String(!open));
    document.body.style.overflow=open?'hidden':'';
  }
  function init(root){
    root=root||document;
    var back=qs('#backTop');
    if(back && !back.dataset.bound){
      back.dataset.bound='true';
      back.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
      window.addEventListener('scroll',function(){back.classList.toggle('visible',window.scrollY>400)},{passive:true});
    }
    qsa('[data-size-input]',root).forEach(function(wrap){
      if(wrap.dataset.bound)return;
      wrap.dataset.bound='true';
      qsa('button',wrap).forEach(function(btn){
        btn.addEventListener('click',function(){
          qsa('button',wrap).forEach(function(b){b.classList.remove('sel')});
          btn.classList.add('sel');
          var input=wrap.querySelector('input[type="hidden"]');
          if(input)input.value=btn.dataset.variantId||btn.value;
        });
      });
    });
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('#navBurger')){e.preventDefault();setMenu(!menuOpen)}
    if(t.closest('#navDrawerBackdrop')||t.closest('[data-drawer-close]')){e.preventDefault();setMenu(false)}
    if(t.closest('#navDrawer a'))setMenu(false);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false)});
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:select',function(e){ if(e.target) e.target.scrollIntoView({behavior:'smooth',block:'center'}); });
  document.addEventListener('shopify:block:select',function(e){ if(e.target) e.target.scrollIntoView({behavior:'smooth',block:'center'}); });
  if(document.readyState !== 'loading') init(document);
})();
